__turbopack_context__.v({
  "benefit": "platform-showcase-module-scss-module__MxtcMG__benefit",
  "benefit-icon": "platform-showcase-module-scss-module__MxtcMG__benefit-icon",
  "benefit-list": "platform-showcase-module-scss-module__MxtcMG__benefit-list",
  "content": "platform-showcase-module-scss-module__MxtcMG__content",
  "copy": "platform-showcase-module-scss-module__MxtcMG__copy",
  "description": "platform-showcase-module-scss-module__MxtcMG__description",
  "heading": "platform-showcase-module-scss-module__MxtcMG__heading",
  "media": "platform-showcase-module-scss-module__MxtcMG__media",
  "showcase": "platform-showcase-module-scss-module__MxtcMG__showcase",
  "text-block": "platform-showcase-module-scss-module__MxtcMG__text-block",
});
